import styled from 'styled-components';

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 20px 24px;
  margin: 15px 0;
  border: 1px solid ${({ theme }) => theme.colors.border || '#e0e0e0'};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white || '#fff'};

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
  `}

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primaryLight || '#e8f5e9'};
  flex-shrink: 0;

  svg {
    width: 32px;
    height: 32px;
    fill: ${({ theme }) => theme.colors.primary || '#2e7d32'};
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h4`
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text || '#333'};
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textLight || '#666'};
  line-height: 1.4;
`;
